// @/components/reusable/forms.jsx
// V2 Form Layout Primitives
//
// FormsSection  — top-level section with vertical spacing between siblings
// FormsArticle  — 2-column responsive grid (header left, fields right)
// FormsHeader   — title + description column for a form section

import React from 'react';
import clsx from 'clsx';

export function FormsSection({ children, className, ...props }) {
  return (
    <section
      {...props}
      className={clsx(className, 'mt-12 first:mt-0')}
    >
      {children}
    </section>
  );
}

export function FormsArticle({ children, className, ...props }) {
  return (
    <article
      {...props}
      className={clsx(className, 'grid gap-x-10 gap-y-5 grid-cols-1 sm:grid-cols-2')}
    >
      {children}
    </article>
  );
}

export function FormsHeader({ children, className, ...props }) {
  return (
    <header
      {...props}
      className={clsx(
        className,
        'flex flex-col gap-1.5 pr-12',
        // Style child Text elements (data-slot="text") automatically
        '*:data-[slot=text]:text-zinc-500'
      )}
    >
      {children}
    </header>
  );
}
